import React from 'react'
import {
  StraitsXSandboxLogo,
  StraitsXPersonalAccountDarkLogo,
  StraitsXBusinessAccountDarkLogo,
} from '@xfers/design-system/es/logos'
import { ConfigManager, SITE_TYPE } from '~/managers/ConfigManager'

type Props = {
  isSandbox: boolean
}

function getStraitsXNavigationLogo({ isSandbox }: Props) {
  const siteType = ConfigManager.getSiteType()
  const isBusinessAccount = siteType === SITE_TYPE.BIZ || siteType === SITE_TYPE.XIDR_BIZ

  if (isSandbox) {
    return <StraitsXSandboxLogo />
  }

  return isBusinessAccount ? (
    <StraitsXBusinessAccountDarkLogo />
  ) : (
    <StraitsXPersonalAccountDarkLogo />
  )
}

export default getStraitsXNavigationLogo
